import {
    DataLabelProps,
    PieChartTooltipOptions,
    PiePlotOptions,
} from "./types";

// // // //

// We don't want to filter any slices for the foreseeable feature
// export const DEFAULT_PIE_CHART_DATA_LABEL_FILTER_PROPS: DataLabelFilterProps = {
//     property: "percentage",
//     operator: ">",
//     value: 0,
// };

export const DEFAULT_PIE_CHART_DATA_LABEL_PROPS: DataLabelProps = {
    enabled: true,
    format: '<span class="fill-muted-foreground" style="font-size:12px; font-weight:400;">{point.name}</span><br/><span dy="5" class="fill-secondary-foreground hidden sm:block" style="font-size:14px; font-weight:400;">${point.dataLabelValue}</span>',
};

export const DEFAULT_PIE_CHART_HEIGHT = 330;

export const DEFAULT_PIE_PLOT_OPTIONS: PiePlotOptions = {
    dataLabels: DEFAULT_PIE_CHART_DATA_LABEL_PROPS,
};

export const DEFAULT_PIE_CHART_TOOLTIP_PROPS: PieChartTooltipOptions = {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "var(--border)",
    backgroundColor: "var(--card)",
    textColor: "var(--foreground)",
    shadow: false,
    useHTML: true,
    format: `
    <div class="flex flex-col mt-1 mb-1 px-2">
        <p class="font-bold text-base">{point.name}</p>
        <span class="text-base tabular-nums">
            <span>$</span>{point.tooltipValue}
        </span>
    </div>
    `,
};
